import React from "react";
import { Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { FormattedMessage } from "react-intl";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { useDispatch } from "react-redux";
import { showSuccessMessage } from "../../actions";

const useStyles = makeStyles({
  root: {
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
  },
  icon: {
    fontSize: "1.2rem",
    verticalAlign: "middle",
  },
});

const CopyText = ({ text, onCopy, successCopyMessage ="app.action.copied" }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    dispatch(showSuccessMessage(successCopyMessage));
    if (onCopy) onCopy();
  };

  return (
    <Tooltip
      title={<FormattedMessage id="app.action.copy.label" />}
      arrow
    >
      <span
        className={classes.root}
        onClick={handleCopy}
      >
        {text}
        <FileCopyIcon className={classes.icon} />
      </span>
    </Tooltip>
  );
};

export default CopyText;
